import React from 'react'
import { problem } from '../../content/csp'

const ProblemSection = () => {
  return (
    <section className="csp-section csp-section--tint">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <span className="csp-kicker">{problem.kicker}</span>
            <h2 className="csp-title">{problem.title}</h2>
            <p className="csp-lead">{problem.lead}</p>
          </div>
        </div>
        <div className="csp-grid csp-grid--3" style={{ marginTop: 40 }}>
          {problem.points.map((point) => (
            <article className="csp-card csp-card--ruled" key={point.title}>
              <h3>{point.title}</h3>
              <p>{point.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ProblemSection
